// src/store/modules/org.js
import apiClient from '@/axios';
import router from '@/router';

const state = {
  dashBoard: {},
  modulesData:[]
};

const getters = {
  getDashData: (state) => state.dashBoard,
  getModulesData: (state) => state.modulesData
};

const mutations = {
  SET_PIPELINE_DATA(state, data) {
    state.dashBoard = data;
  },
  SET_MODULE_DATA(state, data) {
    state.modulesData = data;
  }

};

const actions = {
  async getDashboardData({ commit }, { search, type, page, pageSize, skipGlobalLoader = false }) {
    try {
      const response = await apiClient.get('/dashboard', {
        params: {
          search: search, // Assuming the API expects 'search' as the query parameter
          type: type,  // Assuming the API expects 'filter' for selected option value
          pageSize: pageSize,
          page:page
        },
        skipGlobalLoader: skipGlobalLoader
      });
      if (response.data.status) {
        commit('SET_PIPELINE_DATA', response.data);
        return response.data;
      }
    } catch (error) {
      console.error('Error fetching search results:', error);
      throw error;
    }
  },
  async getOrgData({ commit }, { page, pageSize, skipGlobalLoader = false }) {
    try {
      // const response = await apiClient.get('/dashboard');
      const response = await apiClient.get('/dashboard/organisation', {
        params: {
          pageSize: pageSize,
          page:page
        },
        skipGlobalLoader: skipGlobalLoader
      });
      if (response.data.status) {
        // commit('SET_PIPELINE_DATA', response.data);
        return response.data;
      }
    } catch (error) {
      console.error('Error fetching organisation:', error);
      throw error;
    }
  },
  async getOverDueOpp({ commit }, { page, pageSize, skipGlobalLoader = false }) {
    try {
      // const response = await apiClient.get('/dashboard');
      const response = await apiClient.get('/dashboard/overdue-opportunity', {
        params: {
          pageSize: pageSize,
          page:page
        },
        skipGlobalLoader: skipGlobalLoader
      });

      if (response.data.status) {
        // commit('SET_PIPELINE_DATA', response.data);
        return response.data;
      }
    } catch (error) {
      console.error('Error fetching opportunity:', error);
      throw error;
    }
  },
  async getReportsData({ commit }, { page, pageSize, skipGlobalLoader = false }) {
    try {
      const response = await apiClient.get('/dashboard/reports-charts', {
        params: {
          pageSize: pageSize,
          page:page
        },
        skipGlobalLoader: skipGlobalLoader
      });

      if (response.data.status) {
        // commit('SET_PIPELINE_DATA', response.data);
        return response.data;
      }
    } catch (error) {
      console.error('Error fetching reports & charts:', error);
      throw error;
    }
  },
  async getActivities({ commit }, { page, pageSize, skipGlobalLoader = false }) {
    try {
      const response = await apiClient.get('/dashboard/activities', {
        params: {
          pageSize: pageSize,
          page:page
        },
        skipGlobalLoader: skipGlobalLoader
      });

      if (response.data.status) {
        // commit('SET_PIPELINE_DATA', response.data);
        return response.data;
      }
    } catch (error) {
      console.error('Error fetching activities:', error);
      throw error;
    }
  },
  async getOppCount({ commit }, { params, skipGlobalLoader = false }) {
    try {
      const response = await apiClient.get(`/dashboard/pipeline-wise/opportunities/count?date_range=${params}`, {
        skipGlobalLoader: skipGlobalLoader
      });
      if (response.data.status) {
        // commit('SET_PIPELINE_DATA', response.data);
        return response.data.data;
      }
    } catch (error) {
      console.error('Error fetching pipeline-wise opportunities count:', error);
      throw error;
    }
  },
  async globalSearch({ commit }, payload) {
    try {
      const url = payload.module === 'opp-comment'
        ? '/search/global-opp-comment'
        : `/search/global/${payload.module}`;
      const response = await apiClient.get(url, {
        params: {
          search_term: payload.search,
          page:payload.page
        }
      });
      if (response.data.status) {
        // commit('SET_PIPELINE_DATA', response.data);
        return response.data.data;
      }
    } catch (error) {
      console.error('Error fetching pipeline-wise opportunities count:', error);
    }
  },
  async globalSearchModule({ commit }) {
    try {
      const response = await apiClient.get(`/settings/globalSearch`);
      if (response.data.status) {
        commit('SET_MODULE_DATA', response.data.data.modules);
        return response.data.data.modules;
      }
    } catch (error) {
      console.error('Error fetching module', error);
    }
  },
  async getContracts({ commit }, { page, pageSize, skipGlobalLoader = false }) {
    try {
      const response = await apiClient.get('/dashboard/contracts', {
        params: {
          pageSize: pageSize,
          page:page
        },
        skipGlobalLoader: skipGlobalLoader
      });

      if (response.data.status) {
        return response.data;
      }
    } catch (error) {
      console.error('Error fetching contracts:', error);
      throw error;
    }
  },
  async getSalesRepPerformance({ commit }, { periods, date_from, date_to, skipGlobalLoader = false } = {}) {
    try {
      const params = {};
      if (periods) params.periods = periods;
      if (date_from) params.date_from = date_from;
      if (date_to) params.date_to = date_to;

      const response = await apiClient.get('/dashboard/sales-representative/performance', {
        params,
        skipGlobalLoader,
      });

      if (response.data.status) {
        return response.data;
      }
      throw new Error(response.data?.message || 'Failed to load dashboard');
    } catch (error) {
      console.error('Error fetching sales representative performance:', error);
      throw error;
    }
  },
  async getSalesRepSections(
    { commit },
    { pageSize = 20, sort_by, sort_dir, skipGlobalLoader = false } = {}
  ) {
    try {
      const params = { pageSize };
      if (sort_by) params.sort_by = sort_by;
      if (sort_dir) params.sort_dir = sort_dir;

      const response = await apiClient.get('/dashboard/sales-representative/sections', {
        params,
        skipGlobalLoader,
      });

      if (response.data.status) {
        return response.data;
      }
      throw new Error(response.data?.message || 'Failed to load dashboard sections');
    } catch (error) {
      console.error('Error fetching sales representative sections:', error);
      throw error;
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
